import { render } from "./KeyStats.vue?vue&type=template&id=dfa18d1e&ts=true"
import script from "./KeyStats.vue?vue&type=script&lang=ts"
export * from "./KeyStats.vue?vue&type=script&lang=ts"

import "./KeyStats.vue?vue&type=style&index=0&id=dfa18d1e&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__